import { render } from "./Response.vue?vue&type=template&id=95d40d98&scoped=true"
import script from "./Response.vue?vue&type=script&lang=js"
export * from "./Response.vue?vue&type=script&lang=js"

import "./Response.vue?vue&type=style&index=0&id=95d40d98&scoped=true&lang=css"

import exportComponent from "/builds/sats/careers-application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95d40d98"]])

export default __exports__